module.exports = __webpack_public_path__ + "images/emoji/house.7dc19d97b4b984973f39.png";